module.exports = __webpack_public_path__ + "static/media/guesswhosback.f30194e5.jpg";